import { combineReducers } from 'redux';
import { menu } from './menu.reducer';
import { authentication } from './authentication.reducer';
import { products, product, AddProduct, EditProduct } from './product.reducer';
import { category, createCategory, getCategory, updateCategory, deleteCategory } from './category.reducer';
import { media, mediaUpload, mediaDelete } from './media.reducer';
import { orders, order, orderPayments, orderUpdate } from './order.reducer';
import { transactions } from './transaction.reducer';
import { descriptions, AddDescription, GetDescription, UpdateDescription } from './description.reducer';
import { collections, AddCollection, GetCollection, UpdateCollection } from './collection.reducer';
import {
  productCarousels,
  AddProductCarousel,
  GetProductCarousel,
  UpdateProductCarousel,
} from './product-carousel.reducer';
import { campaigns, AddCampaign, GetCampaign, UpdateCampaign } from './campaign.reducer';
import { prices, AddPrice, GetPrice, UpdatePrice } from './price.reducer';
import { user, users, AddUser, GetUser, UpdateUser } from './user.reducer';
import { admins, AddAdmin, GetAdmin, UpdateAdmin, acl } from './admin.reducer';
import { branches, AddBranch, GetBranch, UpdateBranch } from './branch.reducer';
import { contacts, GetContact, BranchRequests, GetBranchRequest, Jobs, GetJob } from './form.reducer';
import { events, AddEvent, GetEvent, UpdateEvent } from './event.reducer';
import { GetPage, UpdatePage } from './page.reducer';
import { GetSettings, UpdateSettings } from './settings.reducer';
import { sliders, AddSlider, GetSlider, UpdateSlider } from './slider.reducer';
import { faqs, AddFaq, GetFaq, UpdateFaq } from './faq.reducer';
import { discountGroups, AddDiscountGroup, GetDiscountGroup, UpdateDiscountGroup } from './discount-group.reducer';
import { GetCities, GetProvinces } from './city.reducer';
import { shiptimes, AddShiptime, GetShiptime, UpdateShiptime } from './shiptime.reducer';
import { coupons, AddCoupon, GetCoupon, UpdateCoupon } from './coupon.reducer';
import { posts, AddPost, GetPost, UpdatePost } from './post.reducer';
import { packages, AddPackage, GetPackage, UpdatePackage } from './package.reducer';
import { gateways, AddGateway, GetGateway, UpdateGateway } from './gateway.reducer';
import { appLogs } from './app-log.reducer';

export default combineReducers({
  menu,
  authentication,

  products,
  product,
  AddProduct,
  EditProduct,

  category,
  createCategory,
  getCategory,
  updateCategory,
  deleteCategory,

  media,
  mediaUpload,
  mediaDelete,

  orders,
  order,
  orderPayments,
  orderUpdate,

  transactions,

  descriptions,
  AddDescription,
  GetDescription,
  UpdateDescription,

  collections,
  AddCollection,
  GetCollection,
  UpdateCollection,

  productCarousels,
  AddProductCarousel,
  GetProductCarousel,
  UpdateProductCarousel,

  campaigns,
  AddCampaign,
  GetCampaign,
  UpdateCampaign,

  prices,
  AddPrice,
  GetPrice,
  UpdatePrice,

  user,
  users,
  AddUser,
  GetUser,
  UpdateUser,

  admins,
  AddAdmin,
  GetAdmin,
  UpdateAdmin,
  acl,

  branches,
  AddBranch,
  GetBranch,
  UpdateBranch,

  contacts,
  GetContact,
  BranchRequests,
  GetBranchRequest,
  Jobs,
  GetJob,

  events,
  AddEvent,
  GetEvent,
  UpdateEvent,

  GetPage,
  UpdatePage,

  GetSettings,
  UpdateSettings,

  sliders,
  AddSlider,
  GetSlider,
  UpdateSlider,

  faqs,
  AddFaq,
  GetFaq,
  UpdateFaq,

  discountGroups,
  AddDiscountGroup,
  GetDiscountGroup,
  UpdateDiscountGroup,

  GetCities,
  GetProvinces,

  shiptimes,
  AddShiptime,
  GetShiptime,
  UpdateShiptime,

  coupons,
  AddCoupon,
  GetCoupon,
  UpdateCoupon,

  posts,
  AddPost,
  GetPost,
  UpdatePost,

  packages,
  AddPackage,
  GetPackage,
  UpdatePackage,

  gateways,
  AddGateway,
  GetGateway,
  UpdateGateway,

  appLogs,
});
